var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"logo",attrs:{"href":"javascript:"}},[_c('img',{attrs:{"src":_vm.logo}})]),(_vm.$router.currentRoute.meta.auth)?_c('div',[(_vm.noAuth !== 'true')?_c('Auth'):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }